import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import SplitFlapDisplay from "react-split-flap-display";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./useCheckMobileScreen";

const Flapdisplay = (props) => {
  let gaugeheightandwidth = useCheckMobileScreen() ? "0.7rem" : "1.6rem";
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const [state, setState] = useStateIfMounted({
    value: "0", //should be string
    unit: props.unit,
    title: props.title,
    background: "#" + props.background, //energy //"#787879" F0F1F2
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        setState({
          ...state,
          value: message.value == undefined ? "0" : message.value.toString(),
        });
      } catch (error) {
        //console.log(message);
      }
    }
  }
  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  return (
    <div className="col d-flex justify-content-center">
      <div className="card text-center bg-light flapcard">
        <div className="card-header">{state.title + "  " + state.unit}</div>
        <div className="card-body d-flex justify-content-center">
          <SplitFlapDisplay
            characterSet={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
            value={state.value}
            fontSize={gaugeheightandwidth}
            borderWidth="0.1rem"
            minLength={5}
            background={state.background}
            textColor="#000000"
            borderColor="#ffffff"
          />
        </div>
      </div>
    </div>
  );
};
export default Flapdisplay;
